import { CategoriesResponse } from '../../../../models/api/back/create-order/categories';
import { CategoryBlacklistResponse } from '../../../../models/api/front/category-blacklist';
import { AppThunk } from '../../../../app/store';
import { apiActions } from '../../../../slices/api-slice';
import { ordersDataActions } from '../../../../slices/orders/orders-data-slice';
import { commonActions } from '../../../../slices/common-slice';
import { ResponseBase } from '../../../response-base';
import { ApiBaseBack } from '../../api-base-back';
import { isOlcMode } from '../../../../utilities/olc-mode';
import { CustomError } from '../../../../models/custom-error';

const getHiddenServiceIds = (
  blacklist: CategoryBlacklistResponse | null | undefined,
): string[] => {
  return (blacklist?.service ?? []).map((v) => v.serviceId);
};

const filterHiddenCategories = (
  service: CategoriesResponse['service'],
  hiddenIds: string[],
): CategoriesResponse['service'] => {
  if (hiddenIds.length === 0) return service;
  const hiddenSet = new Set(hiddenIds);
  return service.filter((v) => !hiddenSet.has(v.serviceId));
};

// PPM_CLOUD-4207: 非表示単位を「カテゴリ（サービス）」から「製品（productNameId / jptg）」へ変更。
// カテゴリ単位での除外は廃止し、商品取得側 (ApiItems) で productNameId 単位に除外する。
export class ApiCategories extends ApiBaseBack<CategoriesResponse> {

  constructor(param: {
    type?: 'matomete',
  } = {}) {
    super(
      'GET',
      '/api/v1/categories',
      'JSON',
      param,
    );
  }
}

// カテゴリ一覧取得 + ブラックリスト除外
// - 起動モード(URL hash の /ods/ 判定)に応じて ppm / olc の blacklist を参照
// - blacklist 未ロード/空/null どのケースでもフィルタ素通し（壊れない）
export const apiCategoriesThunk = (
  onSuccess?: (filtered: CategoriesResponse) => void,
): AppThunk => async (dispatch, getState) => {
  // カテゴリ取得前に、その時のモードのカテゴリブラックリストを確実に読み込む（後着フィルタ漏れ防止）
  await dispatch(commonActions.ensureBlacklist('category'));
  // 商品ブラックリストは作成画面を開いた時点で先読みする（カテゴリ選択を待たない）。
  // 商品フィルタ直前の apiItemsThunk でも ensureBlacklist('product') を await するため、
  // ここは完了を待たず発火するだけでよい。
  dispatch(commonActions.ensureBlacklist('product'));
  dispatch(apiActions.run(
    new ApiCategories(),
    {
      onSuccess: (res: ResponseBase<CategoriesResponse>) => {
        const blacklist = isOlcMode()
          ? getState().common.data.categoryBlacklistOlc
          : getState().common.data.categoryBlacklist;
        const hiddenIds = getHiddenServiceIds(blacklist);
        const filteredService = filterHiddenCategories(
          res.body.data?.service ?? [],
          hiddenIds,
        );
        const filtered: CategoriesResponse = { service: filteredService };
        dispatch(ordersDataActions.updateItemInfo({
          category: filtered,
        }));
        onSuccess?.(filtered);
      },
    },
  ));
};
